<template>
  <div id="team-container" class="team-page" v-if="!isLoading">
    <c-banner-team />
    <c-team-page-team />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import cBannerTeam from '../../components/team/BannerTeam.vue'
import cTeamPageTeam from '../../components/team/TeamProfile.vue'

export default {
  name: 'Team',
  components: {
    cBannerTeam,
    cTeamPageTeam
  },
  mounted () {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore')

    if (!hasVisitedBefore) {
      this.actionPreloader(true)

      localStorage.setItem('hasVisitedBefore', 'true')

      setTimeout(() => {
        this.actionPreloader(false)
      }, 2000)
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>
<style lang="scss" scoped>
#team-container{
  padding-top: 96px;
}
</style>
